import type { MintCircuitId } from "./types";

const SEPARATOR = "·";

/**
 * The id a created run is keyed by — `${board}·${key}`, which is the run's own
 * convention and not a namespace of our own.
 *
 * It is deliberate: every circuit-keyed map already re-addresses itself through
 * `circuitSuffixOf`, so his cable type and his drops on a run he created
 * survive the board being re-decided between two estimations, exactly as they
 * do for a run the estimation published. A `created:…` prefix would have made
 * this the one circuit whose edits could not follow it.
 */
export const mintCircuitId: MintCircuitId = ({ key, boardName }) => {
  const id = key.trim();
  const board = boardName.trim();
  return board ? `${board}${SEPARATOR}${id}` : id;
};
